// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// CRUD
import { QueryResultsModel } from '../../_base/crud';
// State
import { PrescriptionsState } from '../_reducers/prescription.reducers';
import { each } from 'lodash-es';
import { Prescription } from '../_models/prescription.model';

export const selectPrescriptionsState = createFeatureSelector<PrescriptionsState>('prescriptions');

export const selectPrescriptionById = (prescriptionId: number) =>
  createSelector(
    selectPrescriptionsState,
    (prescriptionsState) => prescriptionsState.entities[prescriptionId],
  );

export const selectPrescriptionsPageLoading = createSelector(
  selectPrescriptionsState,
  (prescriptionsState) => {
    return prescriptionsState.listLoading;
  },
);

export const selectPrescriptionsActionLoading = createSelector(
  selectPrescriptionsState,
  (prescriptionsState) => prescriptionsState.actionsloading,
);

export const selectLastCreatedPrescriptionId = createSelector(
  selectPrescriptionsState,
  (prescriptionsState) => prescriptionsState.lastCreatedPrescriptionId,
);

export const selectLastCreatedPrescription = createSelector(
  selectPrescriptionsState,
  (prescriptionsState) => prescriptionsState.lastCreatedPrescription,
);

export const selectPrescriptionsPageLastQuery = createSelector(
  selectPrescriptionsState,
  (prescriptionsState) => prescriptionsState.lastQuery,
);
export const selectPrescriptionError = createSelector(
  selectPrescriptionsState,
  (prescriptionsState) => prescriptionsState.error,
);
export const selectPrescriptionLatestSuccessfullAction = createSelector(
  selectPrescriptionsState,
  (prescriptionsState) => prescriptionsState.latestSuccessfullAction,
);
export const selectPrescriptionsInStore = createSelector(
  selectPrescriptionsState,
  (prescriptionsState) => {
    const items: Prescription[] = [];
    each(prescriptionsState.ids, (ele) => {
      const index: number = +ele;
      items.push(prescriptionsState.entities[index]);
    });
    return new QueryResultsModel(items, prescriptionsState.totalCount);
  },
);

export const selectPrescriptionsShowInitWaitingMessage = createSelector(
  selectPrescriptionsState,
  (prescriptionsState) => prescriptionsState.showInitWaitingMessage,
);

export const selectHasPrescriptionsInStore = createSelector(
  selectPrescriptionsState,
  (queryResult) => {
    if (!queryResult.totalCount) {
      return false;
    }

    return true;
  },
);
